<header class="header">
  <div class="container">
    <button
      type="button"
      class="menu-btn"
      (click)="onToggleMenu()"
      [attr.aria-label]="menuOpen ? 'Cerrar menu' : 'Abrir menu'"
      [attr.aria-expanded]="menuOpen"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
    <a (click)="goToHome()" class="logo">{{ business.shortName }}</a>
    <button
      type="button"
      class="logout-btn"
      (click)="onLogout()"
      aria-label="Cerrar sesión"
      title="Cerrar sesión"
    >
      <i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i>
    </button>
  </div>
</header>


